import * as React from 'react';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';

type Props = {
  isOpen: boolean;
  errorMessage: string;
  onClose: () => void;
};

export const ClubProgrammeErrorModal: React.FC<Props> = ({ isOpen, errorMessage, onClose }) => {
  if (!isOpen) return null;

  return (
    <SimpleModal
      isOpen={isOpen}
      title="Something went wrong"
      onCloseClick={onClose}
      showFooter={false}
      isBodyBold={false}
      customClass="cpProgrammeDialog cpProgrammeErrorDialog"
      bodyClassName="cpProgrammeDialogBody"
      dialogStyle={{ maxWidth: 440 }}
    >
      <div className="cpProgrammeDialogContent">
        <div className="cpProgrammeDialogLead isDanger">
          <span className="cpProgrammeDialogIcon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="8.5" />
              <path d="M12 7.75v5" />
              <path d="M12 16.25h.01" />
            </svg>
          </span>
          <div>
            <strong>The action could not be completed</strong>
            <p>{errorMessage || 'Please try again.'}</p>
          </div>
        </div>

        <div className="cpProgrammeDialogActions">
          <button type="button" className="cpProgrammeDialogButton isPrimary" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </SimpleModal>
  );
};

ClubProgrammeErrorModal.displayName = 'ClubProgrammeErrorModal';
